var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSingleTickWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 10,
    viewBox: "0 0 13 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7654 0.335646C13.1062 0.748429 13.0716 1.3805 12.6883 1.74742L4.3312 9.74741C3.97938 10.0842 3.4492 10.0842 3.09738 9.74741L0.311672 7.08075C-0.0716261 6.71383 -0.106151 6.08176 0.234558 5.66897C0.575267 5.25619 1.16219 5.21901 1.54549 5.58593L3.71429 7.66205L11.4545 0.252601C11.8378 -0.114316 12.4247 -0.0771358 12.7654 0.335646Z",
    fill: "#DCDBE7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingleTickWhite);
export default __webpack_public_path__ + "static/media/singleTickWhite.d9c994fa004ffcedc04b0394eb2eca3b.svg";
export { ForwardRef as ReactComponent };